var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew273({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 3.7,
    width: 15,
    height: 8.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.37,8.4V8H6.61V9.31A2,2,0,0,1,6,9.72a1.38,1.38,0,0,1-.63.14,1.4,1.4,0,0,1-.76-.21A1.47,1.47,0,0,1,4.09,9,2.27,2.27,0,0,1,3.9,8a2.32,2.32,0,0,1,.2-1,1.4,1.4,0,0,1,.51-.64,1.38,1.38,0,0,1,.76-.21,1.25,1.25,0,0,1,.56.12,1,1,0,0,1,.4.34,1.67,1.67,0,0,1,.24.6l-.35.12A1.39,1.39,0,0,0,6,6.89a.81.81,0,0,0-.28-.24.87.87,0,0,0-.4-.08,1,1,0,0,0-.55.15,1.15,1.15,0,0,0-.37.48A1.94,1.94,0,0,0,4.3,8a1.66,1.66,0,0,0,.3,1.08,1,1,0,0,0,.78.36,1.19,1.19,0,0,0,.47-.11,1.26,1.26,0,0,0,.38-.26V8.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.86,9.8,8,6.22H8.4L9.61,9.8H9.16L8.82,8.72H7.58L7.27,9.8ZM7.7,8.33h1l-.31-1c-.09-.3-.16-.55-.2-.74A5.2,5.2,0,0,1,8,7.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.78,8.65l.37,0a1,1,0,0,0,.13.46.79.79,0,0,0,.3.27,1,1,0,0,0,.43.1.81.81,0,0,0,.54-.17.55.55,0,0,0,.19-.44.51.51,0,0,0-.07-.28.44.44,0,0,0-.21-.19,4.41,4.41,0,0,0-.6-.22,2.28,2.28,0,0,1-.6-.24A1,1,0,0,1,10,7.58a1,1,0,0,1-.1-.43,1,1,0,0,1,.28-.71,1,1,0,0,1,.76-.28,1.14,1.14,0,0,1,.57.13.9.9,0,0,1,.38.37,1.26,1.26,0,0,1,.15.57l-.37,0a.75.75,0,0,0-.21-.51.69.69,0,0,0-.51-.17.75.75,0,0,0-.5.15.46.46,0,0,0-.17.38.47.47,0,0,0,.12.34,1.56,1.56,0,0,0,.58.24,4,4,0,0,1,.61.21,1,1,0,0,1,.54.89,1.09,1.09,0,0,1-.15.56.84.84,0,0,1-.39.38,1.21,1.21,0,0,1-.6.13,1.13,1.13,0,0,1-.86-.32A1.26,1.26,0,0,1,9.78,8.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew273);
export default __webpack_public_path__ + "static/media/Symbolpack_New_273.f5cebdaf90f53558641f26a3d0f8075c.svg";
export { ForwardRef as ReactComponent };